import React from 'react'
import Button from '../Templates/RedesignButton'

/**
 * PriceDetails components allows user change the items quantity and computes total price
 *
 * @component
 *
 * @param {Object} params - The properties of the PriceDetails component
 * @param {number} params.quantity - Number of items for the current product
 * @param {number} [params.price] - Price of current selection
 * @param {boolean} [params.showTotalPrice] - Flag that displays total price section
 * @param {function} params.onChangeQuantity - Function that updates quantity
 * @returns {ReactElement} PriceDetails Component
 */
const PriceDetails = ({
  isExtendedStepper = false,
  price,
  showTotalPrice,
  isLastStep,
  addToCart,
  canProceedToNextStep,
  addingToCart,
}) => {

  return (
    <div className={`${isExtendedStepper ? 'mobile-position' : ''} price-details-wrapper`}>
      {showTotalPrice && (
        <span className="price-wrapper">
          {`$ ${price}`}
        </span>
      )}
      {isLastStep && (
        <Button
          variant="primary"
          className="add-to-cart-button small-button"
          onClick={addToCart}
          disabled={!canProceedToNextStep || addingToCart}
        >
          Add to Cart
        </Button>
      )}
    </div>
  )
}

export default PriceDetails
